import React from "react";

export const AjusteCellRenderer = (params: any) => {

  if (params.node.rowPinned) {
    return null;
  }
  
  let iconState = params.value === 1 || params.value;

  const getTrueIcon = () => {
    return (<span className="ajuste-icon-cell-grid">{'A'}</span>);
  };

  const getFalseIcon = () => {
    return 'No'

  };
  
  return iconState ? getTrueIcon() : getFalseIcon();
};